import { Box, MenuItem, Select, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import React from 'react';
import { useSelector } from 'react-redux';
import { IStoreState } from '@store/index';

type ExportTypeSelectProps = {
  onChange: (value: "video_clip" | "timelapse" | "recurring_timelapse") => void;
  timelapseEnabled: boolean;
  videoClipsEnabled: boolean;
  type?: "video_clip" | "timelapse" | "recurring_timelapse";
}

const ExportTypeSelect: React.FC<ExportTypeSelectProps> = (props) => {
  const { onChange, timelapseEnabled, videoClipsEnabled, type } = props;

  const isSuperAdministrator = useSelector((store: IStoreState) => store.session.isSuperAdministrator);

  return (
    <Box id="timeline-save-video-type-selector-container" width="100%">
      {(videoClipsEnabled || timelapseEnabled) &&
        <>
          <Typography variant="subtitle2">{`Type`}</Typography>
          <Select disabled={videoClipsEnabled === false && timelapseEnabled === false} IconComponent={ExpandMore} fullWidth variant="outlined" value={type} data-cy={`export-type-select`}>
            {videoClipsEnabled && <MenuItem onClick={() => onChange("video_clip")} value="video_clip" data-cy={`export-type-video-menu-item`} >Video clip</MenuItem>}
            {timelapseEnabled && <MenuItem onClick={() => onChange("timelapse")} value="timelapse" data-cy={`export-type-timelapse-menu-item`} >Timelapse</MenuItem>}
            {timelapseEnabled && isSuperAdministrator && <MenuItem onClick={() => onChange("recurring_timelapse")} value="recurring_timelapse" data-cy={`export-type-recurring-timelapse-menu-item`} >Recurring timelapse</MenuItem>}
          </Select>
        </>
      }
      {!videoClipsEnabled && !timelapseEnabled &&
        <Box width="100%" display="flex" flexDirection="row" alignItems="center" justifyContent="center" marginTop="1rem">
          <Typography variant="subtitle2">Exports are not available for this camera.</Typography>
        </Box>
      }
    </Box>
  )
}

export default ExportTypeSelect;
